import React from "react";
import { Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import LicenseServerRoutes from "routes";
import { Home } from "./home";
import { Products } from "./products";
import { Customers } from "./customers";
import { INavLinkGroup, INavStyles, Nav, ShimmerElementType, ShimmerElementsGroup, Stack } from "@fluentui/react";
import { Header } from "@components/header";

const navStyles: Partial<INavStyles> = {
  root: {
    width: 208,
    height: "100%",
    boxSizing: "border-box",
    border: "1px solid #eee",
    overflowY: "auto",
  },
};

const navLinkGroups: INavLinkGroup[] = [
  {
    links: [
      {
        name: "Licenses",
        url: LicenseServerRoutes.Home,
        key: "Licenses",
      },
      {
        name: "Products",
        url: LicenseServerRoutes.Products,
        key: "Products",
      },
      {
        name: "Customers",
        url: LicenseServerRoutes.Customers,
        key: "Customers",
      },
    ],
  },
];

export const PrivateView: React.FC<{ isLogin: boolean }> = observer(function PrivateView({ isLogin }) {
  return (
    <>
      {!isLogin && (
        <ShimmerElementsGroup
          shimmerElements={[
            { type: ShimmerElementType.circle, height: 40 },
            { type: ShimmerElementType.gap, width: 16, height: 40 },
          ]}
        />
      )}
      {isLogin && (
        <div data-testid="private-layout-container">
          <Header />
          <Stack horizontal>
            <Nav selectedKey="key3" ariaLabel="Navigation" styles={navStyles} groups={navLinkGroups} />
            <Routes>
              <Route path={LicenseServerRoutes.Home} element={<Home />} />
              <Route path={LicenseServerRoutes.Products} element={<Products />} />
              <Route path={LicenseServerRoutes.Customers} element={<Customers />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Stack>
        </div>
      )}
    </>
  );
});
